module.exports = __webpack_public_path__ + "static/media/task4Flower4.fa30d519.png";